// extracted by mini-css-extract-plugin
export default {"tupacGrid":"aq-z","tupacHeader":"bq-z","tupacHeader2":"cq-z","tupacMenu":"dq-z","tupacMenu2":"eq-z","tupacMain":"fq-z","tupacMain2":"gq-z"};